// @ts-nocheck
// Exact live version restored from the production sourcemap (portal.rebels.io, 2026-10-23).
import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Alert, Box, Button, CircularProgress, Container, MenuItem, Select, Typography } from '@mui/material';
import dayjs from 'dayjs';
import HoursTable from './table/HoursRegistration';
import { ConfirmationDialog } from './dialog/ConfirmationDialog';
import { FillHours } from './dialog/FillHours';
import { PendingTimeSheet } from './dialog/PendingTimeSheet';
import { OpenTimSheet } from './dialog/OpenTimSheet';
import { AcptedTimSheet } from './dialog/AcptedTimSheet';
import { UploadAction } from '../../../components/common/actions/UploadAction';
import { PrimaryButon } from '../../../components/common/button/PrimaryButon';
import { SecondaryDownloadButton } from '../../../components/common/button/SecondaryDownloadButton';
import { TickCircle } from 'iconsax-react';
import { RejectedTimeSheet } from './dialog/RejectedTimeSheet';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { getTimeSheetCountsByStatusAsync, getTimeSheetForAdminUsingStatus } from '@application/features/timeSheet/timeSheetThunk';
import { HoursStatus } from '@application/common/enums/hours-status';
import { formatShortRange, formatMonthYear } from './hours-dates';
import { translate } from '@application/common/helpers/translate';
import HoursPeriodFilter from './HoursPeriodFilter';
import { ClientContractStatus } from '@application/common/enums/client-contract-status';
import TimeSheetApi from '@infrastructure/timeSheet-api';
import HoursRegistrationApi from '@infrastructure/hours-registration-api';
import { PORTAL_NAVIGATION_REQUEST } from '@ui/components/freelancer/navebar/navigation-guard';
import './weekly-hours.css';
import { downloadBlob } from '@application/common/helpers/file-helper';
import { getErrorPayload } from '@application/common/helpers/api-helper';
import { getRegistrationContextKey, getRegistrationContextLabel, toRegistrationContextWireType } from '@application/features/HoursRegistration/models/registration-context';
const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
// Monthly registration statuses (the chips). Weeks only show whether they are filled in.
const MONTH_STATUSES = [HoursStatus.Rejected, HoursStatus.Open, HoursStatus.Pending, HoursStatus.Approved];
const isWeekFilled = (status) => status === HoursStatus.Complete || status === HoursStatus.Pending || status === HoursStatus.Approved;
const registrationContextId = (registration) => registration.contextId ?? registration.assignmentId ?? registration.internalCompanyId;
const isRegistrationEditable = (registration) => {
    if (registration.assignmentStatus !== ClientContractStatus.Expired)
        return true;
    if (!registration.contractEndDateTime)
        return false;
    return dayjs(registration.contractEndDateTime).isAfter(dayjs());
};
const asApiError = (error) => {
    if (error && typeof error === 'object' && typeof error.status === 'number') {
        return error;
    }
    return getErrorPayload(error);
};
const safeErrorMessage = (error, action) => {
    const apiError = asApiError(error);
    const reference = apiError.correlationId ? ` Reference: ${apiError.correlationId}.` : '';
    const code = apiError.code ? ` (${apiError.code})` : '';
    if (apiError.status === 401)
        return `Your session expired. Sign in again to ${action}.${reference}`;
    if (apiError.status === 403)
        return `You are not allowed to ${action}.${reference}`;
    if (apiError.status === 409)
        return `The timesheet changed while it was open. Review it and try again${code}.${reference}`;
    if (apiError.status === 422)
        return `Hours cannot be processed because routing configuration is incomplete${code}.${reference}`;
    return `The portal could not ${action}${code}. Try again.${reference}`;
};
const contextFromHistory = (data) => {
    const contextType = data.ContextType ?? 'ClientAssignment';
    const contextId = data.ContextId || data.AssignmentId;
    if (!contextId)
        return null;
    return {
        contextType,
        contextId,
        assignmentId: contextType === 'ClientAssignment' ? contextId : null,
        internalDepartmentId: contextType === 'InternalDepartment' ? contextId : '',
        internalDepartmentCode: '',
        displayName: data.clientName || (contextType === 'InternalDepartment' ? 'Internal Department' : 'Client assignment'),
        usesLegacyInternalDepartmentFallback: false
    };
};
export const HoursLogging = () => {
    const { timeSheetsCount } = useAppSelector((state) => state.timeSheet);
    const dispatch = useAppDispatch();
    const [acceptedDialog, setAcceptedDialog] = useState(false);
    const [confirmationDialog, setConfirmationDialog] = useState(false);
    const [fillHours, setFillHours] = useState(false);
    const [pendingTimeSheet, setPendingTimeSheet] = useState(false);
    const [rejectedTimeSheet, setRejectedTimeSheet] = useState(false);
    const [openTimeSheet, setOpenTimeSheet] = useState(false);
    const [uploadedFile, setUploadedFile] = useState(null);
    const [uploadResetKey, setUploadResetKey] = useState(0);
    const [uploadError, setUploadError] = useState(null);
    const [isSubmittingMonth, setIsSubmittingMonth] = useState(false);
    const [selectedDate, setSelectedDate] = useState(dayjs());
    const [period, setPeriod] = useState(null);
    const [historicalContext, setHistoricalContext] = useState(null);
    const [selectedContextKey, setSelectedContextKey] = useState('');
    const [contextWeeks, setContextWeeks] = useState([]);
    const [activeWeekNo, setActiveWeekNo] = useState(null);
    const [isLoadingContexts, setIsLoadingContexts] = useState(true);
    const [isLoadingWeeks, setIsLoadingWeeks] = useState(false);
    const [pageError, setPageError] = useState(null);
    const [weekNotice, setWeekNotice] = useState(null);
    const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);
    const [pdfError, setPdfError] = useState(null);
    const requestSequence = useRef(0);
    const viewSequence = useRef(0);
    const fileSelectionSequence = useRef(0);
    const uploadInFlight = useRef(false);
    const discardInFlight = useRef(false);
    const [editorState, setEditorState] = useState({ dirty: false, saving: false, uncertain: false });
    const updateEditorState = useCallback((state) => setEditorState(state), []);
    const editorRef = useRef(editorState);
    editorRef.current = editorState;
    const guardedNavigate = (action) => {
        if (discardInFlight.current || editorRef.current.saving || editorRef.current.uncertain)
            return;
        if (editorRef.current.dirty && !window.confirm('Discard your unsaved weekly hours?'))
            return;
        action();
    };
    useEffect(() => {
        const beforeUnload = (event) => {
            if (discardInFlight.current || editorRef.current.dirty || editorRef.current.saving || editorRef.current.uncertain) {
                event.preventDefault();
                event.returnValue = '';
            }
        };
        const followLink = (event) => {
            const link = event.target?.closest?.('a[href]');
            if (!link ||
                (!discardInFlight.current && !editorRef.current.dirty && !editorRef.current.saving && !editorRef.current.uncertain))
                return;
            if (discardInFlight.current ||
                editorRef.current.saving ||
                editorRef.current.uncertain ||
                !window.confirm('Discard your unsaved weekly hours?')) {
                event.preventDefault();
                event.stopPropagation();
            }
        };
        const portalNavigation = (event) => {
            if (discardInFlight.current ||
                editorRef.current.saving ||
                editorRef.current.uncertain ||
                (editorRef.current.dirty && !window.confirm('Discard your unsaved weekly hours?')))
                event.preventDefault();
        };
        window.addEventListener('beforeunload', beforeUnload);
        window.addEventListener(PORTAL_NAVIGATION_REQUEST, portalNavigation);
        document.addEventListener('click', followLink, true);
        return () => {
            window.removeEventListener('beforeunload', beforeUnload);
            window.removeEventListener(PORTAL_NAVIGATION_REQUEST, portalNavigation);
            document.removeEventListener('click', followLink, true);
        };
    }, []);
    const selectedMonth = selectedDate.month() + 1;
    const selectedYear = selectedDate.year();
    useEffect(() => {
        setEditorState({ dirty: false, saving: false, uncertain: false });
    }, [selectedContextKey, selectedMonth, selectedYear, activeWeekNo]);
    const validFileTypes = [
        'application/pdf',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'image/png',
        'image/jpeg',
        'image/jpg'
    ];
    const maxFileSize = 16777216;
    const periodContexts = useMemo(() => {
        const result = new Map();
        period?.days.forEach((day) => {
            day.contexts.forEach((context) => result.set(getRegistrationContextKey(context), context));
        });
        return Array.from(result.values());
    }, [period]);
    const contexts = useMemo(() => {
        const result = new Map(periodContexts.map((context) => [getRegistrationContextKey(context), context]));
        [...(period?.historicalContexts ?? []), ...(historicalContext ? [historicalContext] : [])].forEach((context) => {
            const key = getRegistrationContextKey(context);
            if (!result.has(key))
                result.set(key, context);
        });
        return Array.from(result.values());
    }, [historicalContext, period, periodContexts]);
    const selectedContext = contexts.find((context) => getRegistrationContextKey(context) === selectedContextKey) ?? null;
    const selectedWeek = contextWeeks.find((week) => week.weekNo === activeWeekNo) ?? contextWeeks[0] ?? null;
    const contextOptions = contexts.map((context) => ({
        value: getRegistrationContextKey(context),
        label: `${getRegistrationContextLabel(context)}${periodContexts.some((available) => getRegistrationContextKey(available) === getRegistrationContextKey(context)) ? '' : ' · History'}`
    }));
    const getPeriodWeekDescriptors = useCallback((contextPeriod) => {
        const weeks = new Map();
        contextPeriod.days.forEach((day) => {
            const weekNo = day.weekNo;
            const existing = weeks.get(weekNo);
            weeks.set(weekNo, {
                first: existing?.first ?? day.date,
                last: day.date
            });
        });
        return Array.from(weeks.entries()).map(([weekNo, value]) => ({
            weekNo,
            weekStartDate: value.first,
            weekEndDate: value.last
        }));
    }, []);
    const loadContextWeeks = useCallback(async (contextPeriod, context, month, year, preferredWeekNo, requestId) => {
        if (requestId !== requestSequence.current)
            return;
        setIsLoadingWeeks(true);
        setPageError(null);
        setWeekNotice(null);
        try {
            let descriptors = getPeriodWeekDescriptors(contextPeriod);
            // Historical Open/Rejected assignment periods may no longer be
            // present in the current context list. The legacy endpoint is
            // used only to discover week numbers; all rows still come from
            // the owner-scoped typed endpoint.
            if (descriptors.length === 0 && context.contextType === 'ClientAssignment') {
                const legacyWeeks = (await TimeSheetApi.getWeeksByMonthYearAndAssignmentId({
                    Month: month,
                    Year: year,
                    AssignmentId: context.contextId
                })).data;
                descriptors = legacyWeeks.map((week) => ({
                    weekNo: week.weekNo,
                    weekStartDate: week.weekStartDate,
                    weekEndDate: week.weekEndDate
                }));
            }
            const loaded = await Promise.all(descriptors.map(async (descriptor) => {
                try {
                    const response = await HoursRegistrationApi.getContextWeek({
                        year,
                        month,
                        weekNo: descriptor.weekNo,
                        contextType: context.contextType,
                        contextId: context.contextId
                    });
                    return { ...descriptor, data: response.data };
                }
                catch (error) {
                    const apiError = asApiError(error);
                    // A week outside this context can have no rows. Other
                    // failures, including authorization, still surface.
                    if (apiError.status === 400 && apiError.code === 'HOUR_CONTEXT_NOT_AVAILABLE')
                        return null;
                    throw error;
                }
            }));
            if (requestId !== requestSequence.current)
                return;
            const availableWeeks = loaded.filter((week) => week !== null && week.data.rows.length > 0);
            setContextWeeks(availableWeeks);
            const nextWeek = availableWeeks.some((week) => week.weekNo === preferredWeekNo)
                ? preferredWeekNo
                : (availableWeeks[0]?.weekNo ?? null);
            setActiveWeekNo(nextWeek);
            if (preferredWeekNo !== undefined && nextWeek !== preferredWeekNo) {
                setWeekNotice(nextWeek === null
                    ? `Week ${preferredWeekNo} is not available for this registration. No available week was found in the selected month.`
                    : `Week ${preferredWeekNo} is not available for this registration. Showing week ${nextWeek} in the same month.`);
            }
        }
        catch (error) {
            if (requestId !== requestSequence.current)
                return;
            setContextWeeks([]);
            setActiveWeekNo(null);
            setPageError(safeErrorMessage(error, 'load the available timesheets'));
        }
        finally {
            if (requestId === requestSequence.current)
                setIsLoadingWeeks(false);
        }
    }, [getPeriodWeekDescriptors]);
    const loadPeriod = useCallback(async (month, year, preferredContext, preferredWeekNo) => {
        viewSequence.current += 1;
        const requestId = ++requestSequence.current;
        setIsLoadingContexts(true);
        setIsLoadingWeeks(false);
        setPageError(null);
        setWeekNotice(null);
        setPdfError(null);
        setSelectedDate(dayjs(`${year}-${String(month).padStart(2, '0')}-01`));
        setPeriod(null);
        setHistoricalContext(null);
        setSelectedContextKey('');
        setContextWeeks([]);
        setActiveWeekNo(null);
        try {
            const monthStart = dayjs(`${year}-${String(month).padStart(2, '0')}-01`)
                .startOf('month')
                .format('YYYY-MM-DD');
            const monthEnd = dayjs(monthStart).endOf('month').format('YYYY-MM-DD');
            const contextPeriod = (await HoursRegistrationApi.getRegistrationContexts(monthStart, monthEnd)).data;
            if (requestId !== requestSequence.current)
                return;
            setPeriod(contextPeriod);
            setHistoricalContext(preferredContext ?? null);
            const unique = new Map();
            contextPeriod.days.forEach((day) => day.contexts.forEach((context) => unique.set(getRegistrationContextKey(context), context)));
            contextPeriod.historicalContexts?.forEach((context) => {
                const key = getRegistrationContextKey(context);
                if (!unique.has(key))
                    unique.set(key, context);
            });
            const available = Array.from(unique.values());
            const preferredKey = preferredContext ? getRegistrationContextKey(preferredContext) : '';
            const context = available.find((candidate) => getRegistrationContextKey(candidate) === preferredKey) ??
                preferredContext ??
                available[0] ??
                null;
            if (!context) {
                setSelectedContextKey('');
                setContextWeeks([]);
                setActiveWeekNo(null);
                return;
            }
            setSelectedContextKey(getRegistrationContextKey(context));
            await loadContextWeeks(contextPeriod, context, month, year, preferredWeekNo, requestId);
        }
        catch (error) {
            if (requestId !== requestSequence.current)
                return;
            setPeriod(null);
            setHistoricalContext(null);
            setSelectedContextKey('');
            setContextWeeks([]);
            setActiveWeekNo(null);
            setPageError(safeErrorMessage(error, 'load hour-registration contexts'));
        }
        finally {
            if (requestId === requestSequence.current)
                setIsLoadingContexts(false);
        }
    }, [loadContextWeeks]);
    useEffect(() => {
        void loadPeriod(dayjs().month() + 1, dayjs().year());
        void dispatch(getTimeSheetCountsByStatusAsync());
    }, [dispatch, loadPeriod]);
    useEffect(() => {
        void dispatch(getTimeSheetCountsByStatusAsync());
    }, [confirmationDialog, dispatch]);
    const refreshSelectedContext = useCallback(async () => {
        if (!period || !selectedContext)
            return;
        const requestId = ++requestSequence.current;
        await loadContextWeeks(period, selectedContext, selectedMonth, selectedYear, activeWeekNo ?? undefined, requestId);
    }, [activeWeekNo, loadContextWeeks, period, selectedContext, selectedMonth, selectedYear]);
    const handleDateChange = async (month, year) => {
        fileSelectionSequence.current += 1;
        setUploadedFile(null);
        setUploadResetKey((key) => key + 1);
        setUploadError(null);
        await loadPeriod(month, year);
    };
    const handleContextChange = async (contextKey) => {
        const context = contexts.find((candidate) => getRegistrationContextKey(candidate) === contextKey);
        if (!context || !period)
            return;
        const preferredWeekNo = activeWeekNo ?? undefined;
        viewSequence.current += 1;
        const requestId = ++requestSequence.current;
        setSelectedContextKey(contextKey);
        setContextWeeks([]);
        // Retain the desired week during loading, including rapid context switches.
        fileSelectionSequence.current += 1;
        setUploadedFile(null);
        setUploadResetKey((key) => key + 1);
        setUploadError(null);
        setPdfError(null);
        await loadContextWeeks(period, context, selectedMonth, selectedYear, preferredWeekNo, requestId);
    };
    const handleEditTimeSheet = async (data) => {
        if (editorRef.current.saving ||
            editorRef.current.uncertain ||
            (editorRef.current.dirty && !window.confirm('Discard your unsaved weekly hours?')))
            return;
        const context = contextFromHistory(data);
        if (!context)
            return;
        await loadPeriod(Number(data.Month), data.Year, context);
        setOpenTimeSheet(false);
        setRejectedTimeSheet(false);
    };
    const beforeRemoveTimeSheet = () => {
        if (discardInFlight.current || uploadInFlight.current || editorRef.current.saving || editorRef.current.uncertain)
            return false;
        return (!editorRef.current.dirty || window.confirm('Removing a timesheet will reload your weekly hours. Discard your unsaved changes?'));
    };
    const handleRemovedTimeSheet = async () => {
        await dispatch(getTimeSheetForAdminUsingStatus(HoursStatus.Open)).unwrap();
        await dispatch(getTimeSheetCountsByStatusAsync()).unwrap();
        setEditorState({ dirty: false, saving: false, uncertain: false });
        fileSelectionSequence.current += 1;
        setUploadedFile(null);
        setUploadResetKey((key) => key + 1);
        setUploadError(null);
        await loadPeriod(selectedMonth, selectedYear, selectedContext ?? undefined, activeWeekNo ?? undefined);
    };
    const handleFileUpload = (file) => {
        fileSelectionSequence.current += 1;
        if (!file) {
            setUploadedFile(null);
            setUploadError(null);
            return;
        }
        if (!validFileTypes.includes(file.type)) {
            setUploadError(translate('validations.hourDocumentAllowed'));
            setUploadedFile(null);
            setUploadResetKey((key) => key + 1);
            return;
        }
        if (file.size > maxFileSize) {
            setUploadError(translate('validations.maxAllowedFileSize'));
            setUploadedFile(null);
            setUploadResetKey((key) => key + 1);
            return;
        }
        setUploadError(null);
        setUploadedFile(file);
    };
    const uploadMonthlyTimeSheet = async () => {
        if (!uploadedFile || !selectedContext || uploadInFlight.current)
            return;
        uploadInFlight.current = true;
        const submittedViewSequence = viewSequence.current;
        const submittedFileSequence = fileSelectionSequence.current;
        const submittedFile = uploadedFile;
        const submittedContext = selectedContext;
        const submittedMonth = selectedMonth;
        const submittedYear = selectedYear;
        setIsSubmittingMonth(true);
        setUploadError(null);
        try {
            const document = {
                Month: submittedMonth,
                Year: submittedYear,
                TimeSheetDocument: submittedFile,
                ContextType: toRegistrationContextWireType(submittedContext.contextType),
                ContextId: submittedContext.contextId,
                AssignmentId: submittedContext.contextType === 'ClientAssignment' ? submittedContext.contextId : EMPTY_GUID
            };
            await TimeSheetApi.uploadMonthlyTimeSheet(document);
            await dispatch(getTimeSheetCountsByStatusAsync());
            if (submittedViewSequence !== viewSequence.current)
                return;
            await refreshSelectedContext();
            if (submittedViewSequence !== viewSequence.current)
                return;
            setConfirmationDialog(true);
            if (submittedFileSequence === fileSelectionSequence.current) {
                fileSelectionSequence.current += 1;
                setUploadedFile(null);
                setUploadResetKey((key) => key + 1);
            }
        }
        catch (error) {
            if (submittedViewSequence === viewSequence.current && submittedFileSequence === fileSelectionSequence.current) {
                setUploadError(safeErrorMessage(error, 'submit these monthly hours'));
            }
        }
        finally {
            uploadInFlight.current = false;
            setIsSubmittingMonth(false);
        }
    };
    const downloadTimeSheetPdf = async () => {
        if (!selectedContext || selectedContext.contextType !== 'ClientAssignment')
            return;
        setPdfError(null);
        setIsGeneratingPdf(true);
        try {
            const pdf = await TimeSheetApi.downloadMyTimeSheetPdf(selectedContext.contextId, selectedMonth, selectedYear);
            downloadBlob(pdf, `rebels-timesheet-${selectedYear}-${String(selectedMonth).padStart(2, '0')}.pdf`);
        }
        catch (error) {
            setPdfError(safeErrorMessage(error, 'generate this timesheet PDF'));
        }
        finally {
            setIsGeneratingPdf(false);
        }
    };
    const getTimeSheetsByStatus = (status) => {
        dispatch(getTimeSheetForAdminUsingStatus(status))
            .unwrap()
            .then(() => {
            switch (status) {
                case HoursStatus.Open:
                    setOpenTimeSheet(true);
                    break;
                case HoursStatus.Rejected:
                    setRejectedTimeSheet(true);
                    break;
                case HoursStatus.Pending:
                    setPendingTimeSheet(true);
                    break;
                case HoursStatus.Approved:
                    setAcceptedDialog(true);
                    break;
            }
        })
            .catch((error) => setPageError(safeErrorMessage(error, 'load timesheet status')));
    };
    const getStatusCount = (key) => (timeSheetsCount && Object.entries(timeSheetsCount).find(([status]) => status === key)?.[1]) || 0;
    // Monthly registrations behind the status chips (same read-only endpoint as the chip dialogs),
    // kept locally so the dialogs' shared state is not touched. Used for month status labels only.
    const [monthlyRegistrations, setMonthlyRegistrations] = useState([]);
    const monthlySequence = useRef(0);
    const countsKey = timeSheetsCount ? JSON.stringify(timeSheetsCount) : '';
    useEffect(() => {
        if (!countsKey)
            return;
        const requestId = ++monthlySequence.current;
        const statuses = MONTH_STATUSES.filter((status) => getStatusCount(HoursStatus[status]) > 0);
        void Promise.all(statuses.map((status) => TimeSheetApi.getTimeSheetsUsingStatus(status)
            .then((response) => (response.data?.timeSheetWithClientInfo ?? []).map((registration) => ({ ...registration, monthStatus: status })))
            .catch(() => []))).then((lists) => {
            if (requestId === monthlySequence.current)
                setMonthlyRegistrations(lists.flat());
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [countsKey]);
    const monthStatusFor = (month, year, contextId) => {
        const matches = monthlyRegistrations.filter((registration) => Number(registration.month) === month &&
            Number(registration.year) === year &&
            (!contextId || registrationContextId(registration) === contextId));
        return MONTH_STATUSES.find((status) => matches.some((registration) => registration.monthStatus === status));
    };
    const selectedMonthStatus = selectedContext ? monthStatusFor(selectedMonth, selectedYear, selectedContext.contextId) : undefined;
    const rejectedRegistrations = monthlyRegistrations.filter((registration) => registration.monthStatus === HoursStatus.Rejected);
    const firstRejected = rejectedRegistrations[0];
    const isViewingFirstRejected = Boolean(firstRejected &&
        selectedContext &&
        Number(firstRejected.month) === selectedMonth &&
        Number(firstRejected.year) === selectedYear &&
        registrationContextId(firstRejected) === selectedContext.contextId);
    const openRejected = () => {
        if (rejectedRegistrations.length === 1 && isRegistrationEditable(firstRejected)) {
            void handleEditTimeSheet({
                Month: firstRejected.month,
                Year: firstRejected.year,
                AssignmentId: firstRejected.assignmentId ?? '',
                ContextType: firstRejected.bookingContextType === 1 ? 'InternalDepartment' : 'ClientAssignment',
                ContextId: registrationContextId(firstRejected),
                clientName: firstRejected.contextName || firstRejected.allClientNames,
                contractEndDate: firstRejected.contractEndDate
            });
        }
        else {
            getTimeSheetsByStatus(HoursStatus.Rejected);
        }
    };
    const contextDays = selectedContext && period
        ? period.days.filter((day) => day.contexts.some((context) => getRegistrationContextKey(context) === getRegistrationContextKey(selectedContext)))
        : [];
    const contextWeekdays = contextDays.filter((day) => dayjs(day.date).day() % 6 !== 0).length;
    const contextSpanDays = contextDays.length
        ? dayjs(contextDays[contextDays.length - 1].date).diff(dayjs(contextDays[0].date), 'day') + 1
        : 0;
    const contextRange = contextDays.length ? formatShortRange(contextDays[0].date, contextDays[contextDays.length - 1].date) : '';
    // Parts are kept whole when the caption wraps.
    const contextCoverageParts = contextDays.length
        ? [
            contextSpanDays === contextDays.length
                ? `Bookable ${contextRange}`
                : `${contextDays.length} bookable ${contextDays.length === 1 ? 'day' : 'days'} in ${contextRange}`,
            `${contextWeekdays} ${contextWeekdays === 1 ? 'weekday' : 'weekdays'}`
        ]
        : ['Historical timesheet context'];
    const hasCompleteWeek = contextWeeks.some((week) => week.data.weeklyStatus === HoursStatus.Complete);
    const hasWrittenHours = contextWeeks.some((week) => week.data.rows.some((row) => Boolean(row.assignmentReasonId) && row.hours > 0));
    const isInternalContext = selectedContext?.contextType === 'InternalDepartment';
    const canEditWeek = Boolean(selectedWeek?.data.rows.length &&
        selectedContext &&
        selectedWeek.data.rows.every((row) => row.dailyStatus !== HoursStatus.Pending &&
            row.dailyStatus !== HoursStatus.Approved &&
            contextDays.some((day) => day.date === row.date.slice(0, 10))));
    const selectedMonthPrefix = `${selectedYear}-${String(selectedMonth).padStart(2, '0')}`;
    // Saved hours of the selected registration in the selected month (same per-day totals the week view used).
    const selectedMonthTotal = Array.from(new Map(contextWeeks
        .flatMap((week) => week.data.rows)
        .filter((row) => String(row.date).slice(0, 7) === selectedMonthPrefix)
        .map((row) => [String(row.date).slice(0, 10), Number(row.totalHoursInADay) || 0])).values()).reduce((sum, hours) => sum + hours, 0);
    const filledWeeks = contextWeeks.filter((week) => isWeekFilled(week.data.weeklyStatus)).length;
    const monthSteps = [`Weeks filled in (${filledWeeks}/${contextWeeks.length})`, 'Send for approval', 'In progress', 'Approved'];
    const currentMonthStep = selectedMonthStatus === HoursStatus.Approved
        ? 3
        : selectedMonthStatus === HoursStatus.Pending
            ? 2
            : selectedMonthStatus === HoursStatus.Rejected
                ? 1
                : filledWeeks < contextWeeks.length || contextWeeks.length === 0
                    ? 0
                    : 1;
    const isMonthSubmitted = selectedMonthStatus === HoursStatus.Pending || selectedMonthStatus === HoursStatus.Approved;
    const sendBlockedReason = isMonthSubmitted || !selectedContext || contextDays.length === 0 || editorState.dirty || isSubmittingMonth
        ? null
        : !hasCompleteWeek
            ? 'To send this month: fill in at least one complete week.'
            : uploadedFile === null
                ? 'To send this month: upload the signed monthly hours approval.'
                : null;
    const unavailablePeriods = useMemo(() => {
        const ranges = [];
        period?.days.forEach((day) => {
            if (day.contexts.length > 0)
                return;
            const reason = day.unavailableReason || 'No registration context is available for this date. Contact your administrator.';
            const previous = ranges[ranges.length - 1];
            if (previous && previous.reason === reason && dayjs(previous.to).add(1, 'day').format('YYYY-MM-DD') === day.date) {
                previous.to = day.date;
            }
            else {
                ranges.push({ from: day.date, to: day.date, reason });
            }
        });
        return ranges;
    }, [period]);
    return _jsxs(Box, {
        className: 'weekly-hours-page',
        children: [
            _jsxs(Container, {
                maxWidth: 'xl',
                sx: { px: { xs: 2, md: 3 }, py: 2 },
                children: [
                    _jsxs(Box, {
                        sx: { display: 'flex', justifyContent: 'space-between', gap: 2, flexWrap: 'wrap', alignItems: 'center', mb: 1.5 },
                        children: [
                            _jsxs(Box, {
                                children: [
                                    _jsx(Typography, {
                                        component: 'h1',
                                        fontSize: { xs: 26, md: 32 },
                                        fontWeight: 700,
                                        children: 'Hour registration'
                                    }),
                                    _jsx(Typography, {
                                        variant: 'body2',
                                        color: 'text.secondary',
                                        children: 'Register your hours per week and send each month for approval.'
                                    })
                                ]
                            }),
                            _jsxs(Box, {
                                sx: { display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' },
                                'aria-label': 'Monthly registrations by status',
                                children: [
                                    _jsx(Typography, {
                                        variant: 'caption',
                                        color: 'text.secondary',
                                        sx: { mr: 0.5 },
                                        children: 'Monthly registrations'
                                    }),
                                    ...[
                                        { title: 'Open', status: HoursStatus.Open },
                                        { title: 'Pending', status: HoursStatus.Pending },
                                        { title: 'Rejected', status: HoursStatus.Rejected },
                                        { title: 'Approved', status: HoursStatus.Approved }
                                    ].map(({ title, status }) => _jsxs(Button, {
                                        variant: 'outlined',
                                        size: 'small',
                                        color: 'secondary',
                                        onClick: () => getTimeSheetsByStatus(status),
                                        sx: { bgcolor: 'white', gap: 1, minHeight: { xs: 40, sm: 30 } },
                                        children: [
                                            title,
                                            _jsx(Box, {
                                                component: 'span',
                                                fontWeight: 700,
                                                sx: { fontVariantNumeric: 'tabular-nums' },
                                                children: getStatusCount(title)
                                            })
                                        ]
                                    }, title))
                                ]
                            })
                        ]
                    }),
                    firstRejected &&
                        _jsxs(Alert, {
                            severity: 'error',
                            sx: { mb: 2, alignItems: 'center' },
                            action: isViewingFirstRejected && rejectedRegistrations.length === 1
                                ? undefined
                                : _jsx(Button, {
                                    color: 'inherit',
                                    size: 'small',
                                    disabled: editorState.saving || editorState.uncertain,
                                    onClick: openRejected,
                                    sx: { minHeight: 40 },
                                    children: 'View and resubmit'
                                }),
                            children: [
                                _jsxs(Box, {
                                    component: 'span',
                                    fontWeight: 600,
                                    children: [
                                        formatMonthYear(Number(firstRejected.month), Number(firstRejected.year)),
                                        firstRejected.contextName || firstRejected.allClientNames
                                            ? ` (${firstRejected.contextName || firstRejected.allClientNames})`
                                            : '',
                                        ' was rejected.'
                                    ]
                                }),
                                // Shown once the backend supplies the reviewer's reason for this month.
                                firstRejected.rejectionReason ? ` Reason: ${firstRejected.rejectionReason}` : '',
                                rejectedRegistrations.length > 1
                                    ? ` ${rejectedRegistrations.length - 1} more ${rejectedRegistrations.length - 1 === 1 ? 'month was' : 'months were'} rejected.`
                                    : '',
                                isViewingFirstRejected && rejectedRegistrations.length === 1
                                    ? ' Correct the hours below and send this month again.'
                                    : ''
                            ]
                        }),
                    pageError && _jsx(Alert, { severity: 'error', sx: { mb: 2 }, onClose: () => setPageError(null), children: pageError }),
                    weekNotice &&
                        _jsx(Alert, { severity: 'info', sx: { mb: 2 }, onClose: () => setWeekNotice(null), children: weekNotice }),
                    unavailablePeriods.length > 0 &&
                        _jsxs(Alert, {
                            severity: 'warning',
                            sx: { mb: 2 },
                            children: [
                                _jsx(Typography, { variant: 'body2', fontWeight: 600, children: 'Dates unavailable for new hours' }),
                                unavailablePeriods.map((range) => _jsxs(Typography, {
                                    variant: 'body2',
                                    children: [
                                        formatShortRange(range.from, range.to),
                                        ': ',
                                        range.reason
                                    ]
                                }, range.from)),
                                _jsx(Typography, {
                                    variant: 'body2',
                                    children: 'Available dates and previously saved hours remain accessible below.'
                                })
                            ]
                        }),
                    _jsxs(Box, {
                        sx: {
                            bgcolor: 'white',
                            borderRadius: 3,
                            border: '1px solid',
                            borderColor: 'divider',
                            p: { xs: 2, md: 1.5 },
                            display: 'grid',
                            gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: '240px minmax(0, 1fr) 170px' },
                            gap: 2.5,
                            alignItems: 'start'
                        },
                        children: [
                            _jsxs(Box, {
                                children: [
                                    _jsx(Typography, { variant: 'body2', color: 'text.secondary', sx: { mb: 0.75 }, children: 'Period' }),
                                    _jsx(Box, {
                                        sx: {
                                            border: '1px solid',
                                            borderColor: 'divider',
                                            borderRadius: 2,
                                            display: 'inline-block',
                                            '& input': { fontWeight: 600 },
                                            '& .MuiInputBase-root': { color: 'text.primary' }
                                        },
                                        children: _jsx(HoursPeriodFilter, {
                                            onChange: (month, year) => guardedNavigate(() => void handleDateChange(month, year)),
                                            selectedDate: selectedDate,
                                            getMonthStatus: (month, year) => {
                                                if (!selectedContext)
                                                    return undefined;
                                                const status = monthStatusFor(month, year, selectedContext.contextId);
                                                return status === undefined ? undefined : HoursStatus[status];
                                            },
                                            disabled: isLoadingContexts || editorState.saving || editorState.uncertain
                                        })
                                    })
                                ]
                            }),
                            _jsxs(Box, {
                                sx: { minWidth: 0 },
                                children: [
                                    _jsx(Typography, {
                                        variant: 'body2',
                                        color: 'text.secondary',
                                        sx: { mb: 0.75 },
                                        children: 'Assignment / Internal Department'
                                    }),
                                    _jsxs(Select, {
                                        fullWidth: true,
                                        size: 'small',
                                        displayEmpty: true,
                                        value: isLoadingContexts ? '' : selectedContextKey,
                                        disabled: isLoadingContexts || editorState.saving || editorState.uncertain,
                                        inputProps: { 'aria-label': 'Registration context' },
                                        sx: { borderRadius: 2, fontSize: 14, fontWeight: 600 },
                                        onChange: (event) => guardedNavigate(() => void handleContextChange(event.target.value)),
                                        children: [
                                            _jsx(MenuItem, {
                                                value: '',
                                                disabled: true,
                                                children: isLoadingContexts ? 'Loading contexts…' : 'Select registration context'
                                            }),
                                            contextOptions.map((option) => _jsx(MenuItem, { value: option.value, children: option.label }, option.value))
                                        ]
                                    }),
                                    selectedContext &&
                                        // Routing is explained in the weekly editor sidebar; only repeat it here when that editor is not shown.
                                        (contextDays.length === 0 || !canEditWeek) &&
                                        _jsx(Typography, {
                                            variant: 'caption',
                                            color: 'text.secondary',
                                            sx: { display: 'block', mt: 1, lineHeight: 1.5 },
                                            children: contextDays.length === 0
                                                ? 'Historical hours are read-only. This context is unavailable for new hours.'
                                                : isInternalContext
                                                    ? `Only internal hour types · ${selectedContext.displayName}. Workday is unavailable.`
                                                    : 'Workday → client · Other available hours → linked Internal Department'
                                        }),
                                    selectedContext?.isAdditionalInternalBooking &&
                                        _jsx(Typography, {
                                            variant: 'caption',
                                            color: 'text.secondary',
                                            children: 'Additional internal permission \u00B7 client hours remain under the client.'
                                        })
                                ]
                            }),
                            _jsxs(Box, {
                                sx: { alignSelf: 'center', textAlign: { xs: 'left', md: 'right' } },
                                children: [
                                    _jsxs(Typography, {
                                        fontSize: 22,
                                        fontWeight: 700,
                                        children: [
                                            selectedMonthTotal,
                                            ' h',
                                            _jsx(Typography, {
                                                component: 'span',
                                                fontSize: 14,
                                                fontWeight: 400,
                                                children: ` recorded in ${selectedDate.locale('en').format('MMMM')}`
                                            })
                                        ]
                                    }),
                                    _jsx(Typography, {
                                        variant: 'caption',
                                        color: 'text.secondary',
                                        component: 'div',
                                        children: contextCoverageParts.map((part, index) => _jsxs(Box, {
                                            component: 'span',
                                            sx: { whiteSpace: 'nowrap' },
                                            children: [index > 0 ? ' · ' : '', part]
                                        }, part))
                                    })
                                ]
                            })
                        ]
                    }),
                    selectedContext?.usesLegacyInternalDepartmentFallback &&
                        _jsx(Alert, {
                            severity: 'warning',
                            sx: { mt: 2 },
                            children: 'This period still uses a legacy department link. Contact support if submission is rejected.'
                        }),
                    _jsx(Box, {
                        'aria-label': 'Weeks in selected month',
                        'aria-busy': isLoadingWeeks,
                        sx: { display: 'flex', gap: 1.25, my: 1.5, overflowX: 'auto', pb: 0.5 },
                        children: contextWeeks.map((week) => _jsxs(Button, {
                            color: 'secondary',
                            variant: 'outlined',
                            'aria-current': week.weekNo === selectedWeek?.weekNo ? 'true' : undefined,
                            disabled: editorState.saving || editorState.uncertain,
                            onClick: () => {
                                if (week.weekNo !== activeWeekNo)
                                    guardedNavigate(() => setActiveWeekNo(week.weekNo));
                            },
                            sx: {
                                minWidth: 140,
                                flex: '1 0 140px',
                                borderRadius: 3,
                                px: 2,
                                py: 1,
                                display: 'block',
                                textAlign: 'left',
                                bgcolor: week.weekNo === selectedWeek?.weekNo ? 'secondary.main' : 'white',
                                color: week.weekNo === selectedWeek?.weekNo ? 'white' : 'text.primary',
                                '&:hover': { bgcolor: week.weekNo === selectedWeek?.weekNo ? 'secondary.dark' : 'grey.100' }
                            },
                            children: [
                                _jsxs(Box, {
                                    sx: { display: 'flex', justifyContent: 'space-between', gap: 1 },
                                    children: [
                                        _jsxs(Typography, { fontSize: 14, fontWeight: 600, children: ['Week ', week.weekNo] }),
                                        isWeekFilled(week.data.weeklyStatus) &&
                                            _jsx(Box, {
                                                component: 'span',
                                                role: 'img',
                                                'aria-label': 'Week filled in',
                                                title: 'Week filled in',
                                                sx: { display: 'inline-flex', alignItems: 'center' },
                                                children: _jsx(TickCircle, { size: 16, variant: 'Bold', color: 'currentColor' })
                                            })
                                    ]
                                }),
                                _jsxs(Typography, {
                                    fontSize: 12,
                                    sx: { mt: 0.5 },
                                    children: formatShortRange(week.weekStartDate, week.weekEndDate)
                                })
                            ]
                        }, week.weekNo))
                    }),
                    _jsxs(Box, {
                        sx: { bgcolor: 'white', border: '1px solid', borderColor: 'divider', borderRadius: 3, overflow: 'hidden' },
                        children: [
                            _jsxs(Box, {
                                sx: {
                                    px: 3,
                                    py: 1.5,
                                    borderBottom: '1px solid',
                                    borderColor: 'divider',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    gap: 2,
                                    alignItems: 'center'
                                },
                                children: [
                                    _jsxs(Box, {
                                        children: [
                                            _jsx(Typography, {
                                                component: 'h2',
                                                fontSize: 24,
                                                fontWeight: 700,
                                                children: selectedWeek ? `Week ${selectedWeek.weekNo}` : 'Weekly hours'
                                            }),
                                            _jsx(Typography, {
                                                variant: 'body2',
                                                color: 'text.secondary',
                                                children: selectedWeek
                                                    ? formatShortRange(selectedWeek.weekStartDate, selectedWeek.weekEndDate)
                                                    : 'Choose an available context and week.'
                                            })
                                        ]
                                    }),
                                    selectedWeek &&
                                        isWeekFilled(selectedWeek.data.weeklyStatus) &&
                                        _jsxs(Typography, {
                                            variant: 'body2',
                                            color: 'text.secondary',
                                            sx: { display: 'flex', alignItems: 'center', gap: 0.5, whiteSpace: 'nowrap' },
                                            children: [_jsx(TickCircle, { size: 18, variant: 'Bold', color: 'currentColor' }), 'Week filled in']
                                        })
                                ]
                            }),
                            isLoadingContexts || (isLoadingWeeks && !selectedWeek)
                                ? _jsx(Box, {
                                    sx: { minHeight: 280, display: 'grid', placeItems: 'center' },
                                    children: _jsx(CircularProgress, { 'aria-label': 'Loading weekly hours' })
                                })
                                : canEditWeek && selectedWeek && selectedContext
                                    ? _jsx(FillHours, {
                                        presentation: 'inline',
                                        open: true,
                                        handleClose: () => undefined,
                                        week: selectedWeek.data,
                                        context: selectedContext,
                                        onSaved: refreshSelectedContext,
                                        onEditorState: updateEditorState
                                    }, `${selectedContextKey}:${selectedYear}:${selectedMonth}:${selectedWeek.weekNo}`)
                                    : _jsx(HoursTable, {
                                        openDialog: () => setFillHours(true),
                                        week: selectedWeek?.data ?? null,
                                        context: selectedContext,
                                        availableDates: contextDays.map((day) => day.date),
                                        loading: false,
                                        onSaved: refreshSelectedContext
                                    })
                        ]
                    }),
                    _jsxs(Box, {
                        sx: { bgcolor: 'white', border: '1px solid', borderColor: 'divider', borderRadius: 3, mt: 1.5, p: 2 },
                        children: [
                            _jsxs(Box, {
                                sx: { display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', alignItems: 'center', gap: 2 },
                                children: [
                                    _jsxs(Box, {
                                        children: [
                                            _jsxs(Typography, {
                                                component: 'h2',
                                                fontSize: 20,
                                                fontWeight: 700,
                                                children: [
                                                    selectedDate.locale('en').format('MMMM'),
                                                    ' timesheet',
                                                    selectedMonthStatus !== undefined ? ` \u00B7 ${HoursStatus[selectedMonthStatus]}` : ''
                                                ]
                                            }),
                                            _jsx(Typography, {
                                                variant: 'body2',
                                                fontWeight: 600,
                                                sx: { mt: 0.5 },
                                                children: selectedContext
                                                    ? getRegistrationContextLabel(selectedContext)
                                                    : 'No context selected'
                                            }),
                                            selectedContext &&
                                                contextWeeks.length > 0 &&
                                                _jsx(Box, {
                                                    component: 'ol',
                                                    'aria-label': 'Monthly approval steps',
                                                    sx: {
                                                        listStyle: 'none',
                                                        p: 0,
                                                        m: 0,
                                                        mt: 0.5,
                                                        display: 'flex',
                                                        flexWrap: 'wrap',
                                                        columnGap: 0.75,
                                                        rowGap: 0.25
                                                    },
                                                    children: monthSteps.map((step, index) => {
                                                        const done = index < currentMonthStep || (index === 3 && currentMonthStep === 3);
                                                        const current = index === currentMonthStep && !done;
                                                        return _jsxs(Typography, {
                                                            component: 'li',
                                                            variant: 'body2',
                                                            'aria-current': current ? 'step' : undefined,
                                                            color: current ? 'primary.main' : done ? 'text.primary' : 'text.secondary',
                                                            fontWeight: current ? 700 : 400,
                                                            sx: { whiteSpace: 'nowrap' },
                                                            children: [
                                                                index > 0 &&
                                                                    _jsx(Box, {
                                                                        component: 'span',
                                                                        'aria-hidden': true,
                                                                        sx: { color: 'text.secondary', fontWeight: 400, mr: 0.75 },
                                                                        children: '\u2192'
                                                                    }),
                                                                done ? '\u2713 ' : '',
                                                                step
                                                            ]
                                                        }, index);
                                                    })
                                                })
                                        ]
                                    }),
                                    _jsxs(Box, {
                                        sx: { display: 'flex', gap: 1.5, flexWrap: 'wrap', width: { xs: '100%', md: 'auto' } },
                                        children: [
                                            _jsx(Box, {
                                                sx: { width: { xs: '100%', sm: 230 } },
                                                children: _jsx(SecondaryDownloadButton, {
                                                    onClick: downloadTimeSheetPdf,
                                                    loading: isGeneratingPdf,
                                                    disabled: !selectedContext ||
                                                        isInternalContext ||
                                                        !hasWrittenHours ||
                                                        editorState.dirty ||
                                                        editorState.saving
                                                })
                                            }),
                                            _jsx(Box, {
                                                sx: { width: { xs: '100%', sm: 230 } },
                                                children: _jsx(PrimaryButon, {
                                                    onClick: uploadMonthlyTimeSheet,
                                                    disabled: editorState.dirty ||
                                                        editorState.saving ||
                                                        editorState.uncertain ||
                                                        isSubmittingMonth ||
                                                        !hasCompleteWeek ||
                                                        uploadedFile === null ||
                                                        !selectedContext ||
                                                        contextDays.length === 0,
                                                    children: isSubmittingMonth ? 'Sending monthly hours…' : 'Send monthly hours'
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            hasCompleteWeek &&
                                contextDays.length > 0 &&
                                _jsx(Box, {
                                    sx: { mt: 2, maxWidth: 520 },
                                    children: _jsx(UploadAction, {
                                        variant: uploadedFile == null ? 'contained' : 'outLined',
                                        onFileUpload: handleFileUpload,
                                        px: 3,
                                        h: uploadedFile ? 88 : 78,
                                        text: 'Upload monthly hours approval',
                                        singleFile: true,
                                        neutral: true
                                    }, uploadResetKey)
                                }),
                            isInternalContext &&
                                _jsx(Typography, {
                                    variant: 'caption',
                                    color: 'text.secondary',
                                    sx: { display: 'block', mt: 1.5 },
                                    children: 'PDF download remains assignment-based and is not available for a direct Internal Department timesheet yet.'
                                }),
                            sendBlockedReason &&
                                _jsx(Typography, {
                                    variant: 'caption',
                                    color: 'text.secondary',
                                    sx: { display: 'block', mt: 1.5 },
                                    children: sendBlockedReason
                                }),
                            editorState.dirty &&
                                _jsx(Typography, {
                                    variant: 'caption',
                                    color: 'text.secondary',
                                    sx: { display: 'block', mt: 1.5 },
                                    children: 'Save your weekly changes before downloading or sending the monthly timesheet.'
                                }),
                            uploadError && _jsx(Alert, { severity: 'error', sx: { mt: 2 }, children: uploadError }),
                            pdfError && _jsx(Alert, { severity: 'error', sx: { mt: 2 }, children: pdfError })
                        ]
                    })
                ]
            }),
            _jsx(ConfirmationDialog, { open: confirmationDialog, handleClose: () => setConfirmationDialog(false) }),
            _jsx(FillHours, {
                open: fillHours,
                handleClose: () => setFillHours(false),
                week: selectedWeek?.data ?? null,
                context: selectedContext,
                onSaved: refreshSelectedContext
            }),
            _jsx(OpenTimSheet, {
                open: openTimeSheet,
                handleClose: () => setOpenTimeSheet(false),
                onEdit: handleEditTimeSheet,
                beforeRemove: beforeRemoveTimeSheet,
                onRemoved: handleRemovedTimeSheet,
                onRemovalBusy: (busy) => {
                    discardInFlight.current = busy;
                }
            }),
            _jsx(PendingTimeSheet, { open: pendingTimeSheet, handleClose: () => setPendingTimeSheet(false) }),
            _jsx(RejectedTimeSheet, {
                open: rejectedTimeSheet,
                handleClose: () => setRejectedTimeSheet(false),
                onEdit: handleEditTimeSheet
            }),
            _jsx(AcptedTimSheet, { open: acceptedDialog, handleClose: () => setAcceptedDialog(false) })
        ]
    });
};
